function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgBadgeOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#badgeOutlinedIcon_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: c[props.fill] || props.fill || "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10Zm0 1A6 6 0 1 0 8 0a6 6 0 0 0 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM.567 13.107 3.083 8.75l.866.5-1.912 3.312 1.566-.42a.5.5 0 0 1 .612.354l.402 1.5 1.44-2.73.885.467-2.036 3.857a.5.5 0 0 1-.925-.104l-.603-2.249-2.249.603a.5.5 0 0 1-.562-.733ZM15.428 13.107 12.913 8.75l-.866.5 1.912 3.312-1.566-.42a.5.5 0 0 0-.613.354l-.4 1.492-1.42-2.72-.887.463 2.015 3.858a.5.5 0 0 0 .926-.103l.603-2.249 2.25.603a.5.5 0 0 0 .561-.733Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "badgeOutlinedIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
}

SvgBadgeOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgBadgeOutlinedIcon);
export default Memo;